// Normalisation côté client : même logique que backend/phone_utils.py
const KNOWN_CC = ['352', '351', '212', '213', '216', '32', '33', '31', '49', '34', '39', '44', '41', '90', '48', '40', '1'];

export const toE164 = (phone, defaultCc = '32') => {
  if (!phone) return '';
  const cleaned = String(phone).replace(/[^\d+]/g, '');
  const hasPlus = cleaned.startsWith('+');
  const digits = cleaned.replace(/\+/g, '');
  if (!digits) return '';
  if (hasPlus) return `+${digits}`;
  if (digits.startsWith('00') && digits.length > 10) return `+${digits.slice(2)}`;
  if (digits.startsWith('0')) return `+${defaultCc}${digits.replace(/^0+/, '')}`;
  if (digits.length <= 9) return `+${defaultCc}${digits}`;
  if (digits.length >= 11 && KNOWN_CC.some(cc => digits.startsWith(cc))) return `+${digits}`;
  return `+${defaultCc}${digits}`;
};

// Numéro pour wa.me : indicatif + numéro, sans '+' ni espaces
export const toWaNumber = (phone) => toE164(phone).replace(/^\+/, '');

// Numéro exploitable pour WhatsApp (indicatif + au moins 8 chiffres)
export const isValidWaNumber = (phone) => toWaNumber(phone).length >= 10;
